export function blockSheetContentClick(event: MouseEvent): void {
  event.preventDefault();
  event.stopImmediatePropagation();
}
